module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-tree-node",
    class: {
      expanded: _vm.childNodeRendered && _vm.expanded, 'is-current': _vm.tree.currentNode === _vm._self
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "el-tree-node-content",
    style: ({
      'padding-left': _vm.node.level * 16 + 'px'
    }),
    on: {
      "click": _vm.handleExpandIconClick
    }
  }, [_c('span', {
    staticClass: "el-tree-node-expand-icon",
    class: {
      'is-leaf': _vm.node.isLeaf, expanded: !_vm.node.isLeaf && _vm.expanded
    }
  }), _vm._v(" "), (_vm.showCheckbox) ? _c('ElCheckbox', {
    attrs: {
      "indeterminate": _vm.node.indeterminate
    },
    on: {
      "change": _vm.handleCheckChange
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleUserClick($event)
      }
    },
    model: {
      value: (_vm.node.checked),
      callback: function($$v) {
        _vm.$set(_vm.node, "checked", $$v)
      },
      expression: "node.checked"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.node.loading) ? _c('span', {
    staticClass: "el-tree-node-icon el-icon-loading"
  }) : _vm._e(), _vm._v(" "), _c('node-content', {
    attrs: {
      "node": _vm.node
    }
  })], 1), _vm._v(" "), _c('CollapseTransition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "el-tree-node-children"
  }, _vm._l((_vm.node.childNodes), function(child) {
    return _c('el-tree-node', {
      key: _vm.getNodeKey(child),
      attrs: {
        "render-content": _vm.renderContent,
        "node": child
      }
    })
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4360071c!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/src/tree-node.vue
// module id = 643
// module chunks = 0